// Class: starling.text.TextFieldAutoSize

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var TextFieldAutoSize = function(){}

// Meta

TextFieldAutoSize.__name__ = "starling.text.TextFieldAutoSize";
TextFieldAutoSize.__isInterface__ = false;
TextFieldAutoSize.prototype = {
	
};
TextFieldAutoSize.prototype.__class__ = TextFieldAutoSize.prototype.constructor = $hxClasses["starling.text.TextFieldAutoSize"] = TextFieldAutoSize;

// Init



// Statics


TextFieldAutoSize.NONE = "none"
TextFieldAutoSize.HORIZONTAL = "horizontal"
TextFieldAutoSize.VERTICAL = "vertical"
TextFieldAutoSize.BOTH_DIRECTIONS = "bothDirections"

// Export

exports.default = TextFieldAutoSize;